/*
* @Author: abhishek714
* @Date:   2025-05-06 14:44:23
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-05-06 15:46:38
*/
export const us_territories = [
    { "value": "Argentina", "label": "Argentina" },
    { "value": "Belize", "label": "Belize" },
    { "value": "Bolivia", "label": "Bolivia" },
    { "value": "Brazil", "label": "Brazil" },
    { "value": "Chile", "label": "Chile" },
    { "value": "Colombia", "label": "Colombia" },
    { "value": "Costa Rica", "label": "Costa Rica" },
    { "value": "Dominican Republic", "label": "Dominican Republic" },
    { "value": "Ecuador", "label": "Ecuador" },
    { "value": "French Guiana", "label": "French Guiana" },
    { "value": "Guatemala", "label": "Guatemala" },
    { "value": "Haiti", "label": "Haiti" },
    { "value": "Honduras", "label": "Honduras" },
    { "value": "Jamaica", "label": "Jamaica" },
    { "value": "Mexico", "label": "Mexico" },
    { "value": "Nicaragua", "label": "Nicaragua" },
    { "value": "Panama", "label": "Panama" },
    { "value": "Paraguay", "label": "Paraguay" },
    { "value": "Peru", "label": "Peru" },
    { "value": "Puerto Rico", "label": "Puerto Rico" },
    { "value": "Suriname", "label": "Suriname" },
    { "value": "Trinidad", "label": "Trinidad" },
    { "value": "Uruguay", "label": "Uruguay" },
    { "value": "Venezuela", "label": "Venezuela" },
    { "value": "Virgin Islands", "label": "Virgin Islands" }
];

export default us_territories;